import { render, staticRenderFns } from "./ModalCacambaTemporaria.vue?vue&type=template&id=13b122bc&scoped=true"
import script from "./ModalCacambaTemporaria.vue?vue&type=script&lang=js"
export * from "./ModalCacambaTemporaria.vue?vue&type=script&lang=js"
import style0 from "./ModalCacambaTemporaria.vue?vue&type=style&index=0&id=13b122bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b122bc",
  null
  
)

export default component.exports